import apiClient from './api';
import {
  FiscalPeriodDto,
  CreateFiscalPeriodDto,
  UpdateFiscalPeriodDto,
  GeneratePeriodsRequest
} from '../types/fiscalPeriods.types';

class FiscalPeriodsService {
  private baseUrl = '/FiscalPeriods';

  async getAll(): Promise<FiscalPeriodDto[]> {
    const response = await apiClient.get(this.baseUrl);
    return response.data;
  }

  async getById(id: number): Promise<FiscalPeriodDto> {
    const response = await apiClient.get(`${this.baseUrl}/${id}`);
    return response.data;
  }

  async getCurrent(): Promise<FiscalPeriodDto> {
    const response = await apiClient.get(`${this.baseUrl}/current`);
    return response.data;
  }

  async create(data: CreateFiscalPeriodDto): Promise<FiscalPeriodDto> {
    const response = await apiClient.post(this.baseUrl, data);
    return response.data;
  }

  async update(id: number, data: UpdateFiscalPeriodDto): Promise<FiscalPeriodDto> {
    const response = await apiClient.put(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }

  async close(id: number): Promise<FiscalPeriodDto> {
    const response = await apiClient.post(`${this.baseUrl}/${id}/close`);
    return response.data;
  }

  async open(id: number): Promise<FiscalPeriodDto> {
    const response = await apiClient.post(`${this.baseUrl}/${id}/open`);
    return response.data;
  }

  async setCurrent(id: number): Promise<FiscalPeriodDto> {
    const response = await apiClient.post(`${this.baseUrl}/${id}/set-current`);
    return response.data;
  }

  async generate(request: GeneratePeriodsRequest): Promise<FiscalPeriodDto[]> {
    const response = await apiClient.post(`${this.baseUrl}/generate`, request);
    return response.data;
  }

  // ============================================
  // ✅ Database Operations
  // ============================================
  
  async generateDatabase(newDatabaseName: string, sourceFiscalPeriodId: number): Promise<{
    success: boolean;
    message: string;
    connectionString?: string;
    databaseName?: string;
  }> {
    const response = await apiClient.post(`${this.baseUrl}/generate-database`, {
      newDatabaseName,
      sourceFiscalPeriodId
    });
    return response.data;
  }

  async convertToMain(id: number): Promise<{
    success: boolean;
    message: string;
  }> {
    const response = await apiClient.post(`${this.baseUrl}/${id}/convert-to-main`);
    return response.data;
  }

  async deleteSeparateDatabase(id: number): Promise<{
    success: boolean;
    message: string;
  }> {
    const response = await apiClient.post(`${this.baseUrl}/${id}/delete-database`);
    return response.data;
  }
}

export const fiscalPeriodsService = new FiscalPeriodsService();